import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/BsEnIso/gridFieldSets';
import React from 'react';
import { useSelector } from 'react-redux';

let BsPreparationDryingSpecimenGridSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  return (
    <WorksheetGridFieldSection name="TestPortions">
      <WorksheetRecordGrid
        name={'TestPortions'}
        orientation={'horizontal'}
        rowHeaderWidth={200}
        recordProps={{
          width: 130,
          preventRemove: (i) => i < 2,
          heading: 'number',
          headingLabel: 'Specimen',
        }}
        fieldSet={[
          ...prefixRecordFieldSetNames(
            'MoistureDetermination',
            getMoistureContentGridFieldSet(dryMassEntryOption)
          ).filter((x) => {
            return x.name !== 'MoistureDetermination.Results.MoistureContentPercent';
          }),
          {
            name: 'MoistureDetermination.DryingTray.ConstantDrySoilMass',
            component: <Field input={<TextOutput />} />,
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

BsPreparationDryingSpecimenGridSection = withInjectedProps(BsPreparationDryingSpecimenGridSection);

export { BsPreparationDryingSpecimenGridSection };
export default BsPreparationDryingSpecimenGridSection;
